import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/themes.css";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals";

// Aplicar tema antes del primer render para evitar flash
const savedTheme = localStorage.getItem("theme");
if (!savedTheme || savedTheme === "light") {
  document.body.classList.add("light-theme");
  if (!savedTheme) localStorage.setItem("theme", "light");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
